'use client';

import { useRoutes } from 'react-router-dom';
import MainContentWrapper from '@/lib/components/MainContentWrapper.tsx';
import { routes } from './routes.tsx';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function App() {
  const path = useLocation().pathname;
  const element = useRoutes(routes);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [path]);

  return (
    <>
      <MainContentWrapper>{element}</MainContentWrapper>
    </>
  );
}

export default App;
